export const actionLogActions = {
  createOrganizationForAdmin: 'Agent created a organization',
  updateOrganizationForAdmin: 'Agent updated a organization',
  updateMyPasswordForAdmin: 'Admin updated his password',
  updateMyPasswordForAgent: 'Agent updated his password',
  createAdminForAdmin: 'Admin created another admin',
  updateAdminForAdmin: 'Admin updated another admin',
  createAgentForAdmin: 'Admin created a agent',
  updateAgentForAdmin: 'Admin updated a agent',
  createUpgradePostForAdmin: 'Admin created a upgrade post',
  updateUpgradePostForAdmin: 'Admin updated a upgrade post',
  stopPaidSubscriptionPlanForAgent: 'Agent stopped a paid subscription plan',
  continuePaidSubscriptionPlanForAgent: 'Agent continued a paid subscription plan',
  // startPaidSubscriptionPlanForAgent: 'Agent started a paid subscription plan',
  // refreshPaidSubscriptionPlanForAgent: 'Agent refreshed a paid subscription plan',
  buyAgentSubscriptionPlanForAgentSuccess: 'Agent bought a paid subscription plan successfully',
  buyAgentSubscriptionPlanForAgentFailed: 'Agent bought a paid subscription plan failed',
  buyAgentSubscriptionPlanForAgentRefunded: 'Agent bought a paid subscription plan refunded',
  stopAgentPaidSubscriptionPlanForAdmin: 'Admin stopped a agent paid subscription plan',
  buyPermanentRecognitionTokensForAgentSuccess: 'Agent bought permanent recognition tokens successfully',
  buyPermanentRecognitionTokensForAgentFailed: 'Agent bought permanent recognition tokens failed',
  buyPermanentRecognitionTokensForAgentRefunded: 'Agent bought permanent recognition tokens refunded',
  buyPermanentScenarioTokensForAgentSuccess: 'Agent bought permanent scenario tokens successfully',
  buyPermanentScenarioTokensForAgentFailed: 'Agent bought permanent scenario tokens failed',
  buyPermanentScenarioTokensForAgentRefunded: 'Agent bought permanent scenario tokens refunded',
  addBankCardForAgentSuccess: 'Agent added a bank card successfully',
  addBankCardForAgentFailed: 'Agent added a bank card failed',
  addBankCardForAgentRefunded: 'Agent added a bank card refunded',
  removeBankCardForAgent: 'Agent removed a bank card',
  addAgentPermanentRecognitionTokensForAdmin: 'Admin added permanent recognition tokens to a agent',
  addAgentPermanentScenarioTokensForAdmin: 'Admin added permanent scenario tokens to a agent',
  systemRefreshAgentPaidSubscriptionPlanSuccess: 'System refreshed a agent paid subscription plan',
  systemRefreshAgentPaidSubscriptionPlanFailed: 'System failed to refresh a agent paid subscription plan',
  systemRefreshAgentFreeSubscriptionPlanSuccess: 'System refreshed a agent free subscription plan',
  systemRefreshAgentPaidSubscriptionPlanFallbackToFreeBecouseNotShouldRefreshPaidSubscriptionPlan:
    'System refreshed a agent paid subscription plan and fallback to free becouse not should refresh paid subscription plan',
  systemRefreshAgentPaidSubscriptionPlanFallbackToFreeBecouseMaxRefreshTriesCount:
    'System refreshed a agent paid subscription plan and fallback to free becouse max refresh tries count',
  createAgentsBatchForAdmin: 'Admin created a batch of agents',
}
export type ActionLogAction = keyof typeof actionLogActions
export const toHumanActionLogAction = (action: string): string => {
  return (actionLogActions as any)[action] || action
}
